import { render } from "./PlacesItem.vue?vue&type=template&id=61c79d18&ts=true"
import script from "./PlacesItem.vue?vue&type=script&lang=ts"
export * from "./PlacesItem.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__